import React from 'react';
import UnderDevelopment from '../../components/UnderDevelopment';
function PartnersAndClients() {
    return(
        <UnderDevelopment/>
    );
}
export default PartnersAndClients;